import { Component, Input, NgZone, OnDestroy, OnInit, signal } from '@angular/core';
import moment from 'moment';
import { BREAK_TYPE_ENUM } from '../../../../../constants/lookup/common/break-type.enum';
import { TimesheetEnum } from '../../../../../constants/lookup/timesheet/timesheet-status.enum';
import { ModalBaseClass } from '../../../../shared/components/modals/base_class/modal-base-class';
import { ShiftBreakActualDetailsComponent } from '../shift-break-actual-details/shift-break-actual-details.component';
import { PERMISSIONV2 } from '../../../../../constants/permissionv2/role-permission';
import { MasterService } from '../../../../../state/master/services/master.service';
import { DateUtil } from '../../../../../core/utils/date-util';

@Component({
  standalone: false,
  selector: 'kt-actual-shift-details',
  templateUrl: './actual-shift-details.component.html',
  styleUrls: ['./actual-shift-details.component.scss']
})
export class ActualShiftDetailsComponent extends ModalBaseClass implements OnInit, OnDestroy {
  @Input() timesheetDetails = null;
  timesheetStatusRef = TimesheetEnum;
  timeElapsed = signal('');
  interval = null;
  @Input() shiftDetails = null;
  @Input() shiftAllInfo = null;
  permissionV2 = PERMISSIONV2
  masterBusinessLabel = MasterService.masterBusinessLabel


  setTimeElapsed() {
    // parse start date in its timezone
    const start = moment.tz(this.timesheetDetails.timesheet_actual_start_date, 'YYYY-MM-DDTHH:mm:ss', this.timesheetDetails.location.location_fk_timezone_name);

    // current time in same timezone
    const now =  DateUtil.getCurrentDateTimeWithLocationTimezone(this.timesheetDetails.location.location_fk_timezone_name );

    const seconds = Math.abs(start.diff(now, 'seconds'));

    // const seconds = Math.abs(moment(this.timesheetDetails.timesheet_actual_start_date, 'YYYY-MM-DDTHH:mm:ss').diff(moment(), 'seconds', false));
    const hours = Math.floor(seconds / 3600).toString().padStart(2, '0');
    const minutes = Math.floor(seconds / 60).toString().padStart(2, '0');
    this.timeElapsed.set(`${hours} Hrs  ${(+minutes) - ((+hours) * 60)} Mins  `);
  }

  ngOnInit() {
    this.setTimeElapsed();
    this.interval = setInterval(() => {
      this.setTimeElapsed();
    }, 60000);
  }


  restClickHandler() {
    this.openPopUp(ShiftBreakActualDetailsComponent, { type: BREAK_TYPE_ENUM.RestBreak, shiftId: this.shiftDetails ? this.shiftDetails.shift_id : 0, timesheetId: this.timesheetDetails.timesheet_id }, { centered: true, size: 'md', backdrop: 'static' });

  }

  mealBreakHandler() {
    this.openPopUp(ShiftBreakActualDetailsComponent, { type: BREAK_TYPE_ENUM.MealBreak, shiftId: this.shiftDetails ? this.shiftDetails.shift_id : 0, timesheetId: this.timesheetDetails.timesheet_id}, { centered: true, size: 'md', backdrop: 'static' });

  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}
